/* 2C Bordados · Ficha de producto: fotos, opciones, personalización y carrito */
import { CartAddEvent } from '@theme/events';

const money = (cents) => {
  const n = Math.round(cents) / 100;
  const hasDec = Math.round(cents) % 100 !== 0;
  return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: hasDec ? 2 : 0, maximumFractionDigits: 2 });
};

class TcProduct {
  constructor(root) {
    this.root = root;
    const dataEl = root.querySelector('[data-tc-data]');
    this.data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [], media: {} };
    this.main = root.querySelector('[data-tc-main]');
    this.area = root.querySelector('[data-tc-area]');
    this.priceEl = root.querySelector('[data-tc-price]');
    this.totalEl = root.querySelector('[data-tc-total]');
    this.addBtn = root.querySelector('[data-tc-add]');
    this.qtyEl = root.querySelector('[data-tc-qty]');
    this.msgEl = root.querySelector('[data-tc-msg]');
    this.fileEl = root.querySelector('[data-tc-file]');
    this.groups = [...root.querySelectorAll('[data-tc-opt]')];
    this.persos = [...root.querySelectorAll('[data-tc-persos] .tc-po')];
    this.variant = this.data.variants.find((v) => v.id === this.data.selected) || this.data.variants[0] || null;
    this.bind();
    this.update(false);
  }

  /* ---------- Estado actual ---------- */
  selected(group) {
    const on = group.querySelector('.is-on');
    return on ? on.dataset.value : null;
  }
  realGroups() {
    return this.groups.filter((g) => g.dataset.pos);
  }
  pseudoGroups() {
    return this.groups.filter((g) => !g.dataset.pos);
  }
  findVariant() {
    const real = this.realGroups();
    if (!this.data.hasVariants || real.length === 0) return this.data.variants[0] || null;
    return (
      this.data.variants.find((v) =>
        real.every((g) => v.o[Number(g.dataset.pos) - 1] === this.selected(g))
      ) || null
    );
  }
  perso() {
    const on = this.persos.find((p) => p.classList.contains('is-on'));
    if (!on) return { price: 0, label: '', addons: [] };
    return {
      price: Number(on.dataset.p || 0),
      label: on.dataset.label || '',
      addons: (on.dataset.addon || '').split(',').filter(Boolean).map(Number),
    };
  }
  qty() {
    return Math.max(1, parseInt(this.qtyEl?.value || '1', 10) || 1);
  }

  /* ---------- Eventos ---------- */
  bind() {
    this.groups.forEach((g) => {
      g.addEventListener('click', (e) => {
        const btn = e.target.closest('button[data-value]');
        if (!btn) return;
        g.querySelectorAll('button[data-value]').forEach((b) => {
          b.classList.toggle('is-on', b === btn);
          b.setAttribute('aria-checked', String(b === btn));
        });
        if (g.dataset.kind === 'color') {
          const nameEl = g.querySelector('[data-tc-colorname]');
          if (nameEl) nameEl.textContent = btn.dataset.value;
        }
        if (g.dataset.kind === 'corte') this.showCorte(btn.dataset.value);
        this.update(true, g.dataset.kind);
      });
    });

    this.persos.forEach((p) =>
      p.addEventListener('click', () => {
        this.persos.forEach((x) => {
          x.classList.toggle('is-on', x === p);
          x.setAttribute('aria-checked', String(x === p));
        });
        this.updateTotal();
      })
    );

    this.root.querySelectorAll('[data-tc-thumb]').forEach((t) =>
      t.addEventListener('click', () => this.showMedia(t.dataset.tcThumb, t))
    );

    this.root.querySelector('[data-tc-minus]')?.addEventListener('click', () => {
      this.qtyEl.value = String(Math.max(1, this.qty() - 1));
      this.updateTotal();
    });
    this.root.querySelector('[data-tc-plus]')?.addEventListener('click', () => {
      this.qtyEl.value = String(this.qty() + 1);
      this.updateTotal();
    });
    this.qtyEl?.addEventListener('input', () => this.updateTotal());
    this.qtyEl?.addEventListener('change', () => {
      this.qtyEl.value = String(this.qty());
      this.updateTotal();
    });

    this.fileEl?.addEventListener('change', () => {
      const label = this.root.querySelector('[data-tc-filename]');
      const wrap = this.root.querySelector('[data-tc-filelabel]');
      const f = this.fileEl.files && this.fileEl.files[0];
      if (f && f.size > 20 * 1024 * 1024) {
        this.say('El archivo pesa más de 20 MB. Mándanoslo por WhatsApp, por favor.', true);
        this.fileEl.value = '';
        return;
      }
      if (label) label.textContent = f ? 'Logo: ' + f.name : label.dataset.default || label.textContent;
      wrap?.classList.toggle('has-file', Boolean(f));
    });
    const fl = this.root.querySelector('[data-tc-filename]');
    if (fl) fl.dataset.default = fl.textContent;

    this.addBtn?.addEventListener('click', () => this.add());
  }

  /* ---------- Fotos ---------- */
  showMedia(id, thumb) {
    const m = this.data.media[id];
    if (!m || !this.main) return;
    if (this.main.dataset.mediaId !== String(id)) {
      this.main.classList.add('is-loading');
      const done = () => this.main.classList.remove('is-loading');
      this.main.addEventListener('load', done, { once: true });
      this.main.addEventListener('error', done, { once: true });
      this.main.srcset = m.srcset;
      this.main.src = m.src;
      this.main.alt = m.alt;
      this.main.dataset.mediaId = String(id);
    }
    const showArea = Boolean(thumb && thumb.dataset.area);
    if (this.area) this.area.hidden = !showArea;
    this.root.querySelectorAll('[data-tc-thumb]').forEach((t) => {
      const on = thumb ? t === thumb : t.dataset.tcThumb === String(id) && !t.dataset.area;
      t.classList.toggle('is-on', on);
    });
  }
  showCorte(value) {
    const want = (value || '').toLowerCase().startsWith('d') ? 'd' : 'c';
    const t = this.root.querySelector(`[data-tc-thumb][data-corte="${want}"]`);
    if (t) {
      this.showMedia(t.dataset.tcThumb, t);
      t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    document.dispatchEvent(new CustomEvent('tc:corte', { detail: { corte: want === 'd' ? 'dama' : 'caballero' } }));
  }

  /* ---------- Precio, disponibilidad y foto de la variante ---------- */
  update(fromUser, kind) {
    const v = this.findVariant();
    this.variant = v;
    if (v && this.priceEl) this.priceEl.textContent = money(v.p);
    if (fromUser && v && v.m && kind !== 'corte') this.showMedia(String(v.m));
    if (fromUser && v && this.data.hasVariants && this.realGroups().length) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(v.id));
      window.history.replaceState({}, '', url.toString());
    }
    if (this.addBtn) {
      const ok = Boolean(v && v.a);
      this.addBtn.disabled = !ok;
      this.addBtn.textContent = !v ? 'No disponible en esta combinación' : v.a ? this.data.addLabel : 'Agotado';
    }
    this.markUnavailable();
    this.updateTotal();
  }
  markUnavailable() {
    const real = this.realGroups();
    if (!this.data.hasVariants || real.length === 0) return;
    real.forEach((g) => {
      const pos = Number(g.dataset.pos) - 1;
      g.querySelectorAll('button[data-value]').forEach((b) => {
        const match = this.data.variants.some(
          (v) =>
            v.a &&
            v.o[pos] === b.dataset.value &&
            real.every((o) => o === g || v.o[Number(o.dataset.pos) - 1] === this.selected(o))
        );
        b.classList.toggle('is-out', !match && this.data.variants.length < 250);
      });
    });
  }
  updateTotal() {
    if (!this.totalEl || !this.variant) return;
    const p = this.perso();
    const unit = this.variant.p + (p.price > 0 ? p.price : 0);
    this.totalEl.textContent = money(unit * this.qty()) + (p.price < 0 ? ' + bordado' : '');
  }

  /* ---------- Carrito ---------- */
  say(text, isError) {
    if (!this.msgEl) return;
    this.msgEl.textContent = text || '';
    this.msgEl.classList.toggle('is-error', Boolean(isError));
  }
  description() {
    return this.groups.map((g) => this.selected(g)).filter(Boolean).join(' / ');
  }
  async add() {
    const v = this.variant;
    if (!v || !v.a || this.addBtn.classList.contains('is-busy')) return;
    const qty = this.qty();
    const p = this.perso();
    this.addBtn.classList.add('is-busy');
    this.say('');

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    const form = new FormData();
    form.append('id', String(v.id));
    form.append('quantity', String(qty));
    this.pseudoGroups().forEach((g) => {
      const val = this.selected(g);
      if (val) form.append(`properties[${g.dataset.tcOpt}]`, val);
    });
    if (p.label) form.append('properties[Personalización]', p.label + (p.price < 0 ? ' (a cotizar)' : ''));
    if (this.data.gorra && !p.label) form.append('properties[Personalización]', 'Bordado frontal incluido');
    if (this.fileEl && this.fileEl.files && this.fileEl.files[0]) form.append('properties[Logo]', this.fileEl.files[0]);
    if (!p.addons.length && sectionIds.length) form.append('sections', sectionIds.join(','));

    try {
      let res = await fetch(window.Shopify?.routes?.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: form,
      });
      let json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || json.message || 'No se pudo agregar');

      if (p.addons.length) {
        const forWhat = `${this.data.productTitle}${this.description() ? ' · ' + this.description() : ''}`;
        res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: p.addons.map((id) => ({ id, quantity: qty, properties: { Prenda: forWhat } })),
            sections: sectionIds.join(','),
          }),
        });
        json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || json.message || 'No se pudo agregar el bordado');
      }

      const cart = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then((r) => r.json()).catch(() => undefined);
      this.root.dispatchEvent(
        new CartAddEvent(cart, String(v.id), {
          source: 'tc-product',
          itemCount: qty,
          productId: String(v.id),
          sections: json.sections,
        })
      );
      this.say((p.label && !this.data.gorra) || this.data.gorra ? this.data.addedMsgPerso || this.data.addedMsg : this.data.addedMsg || '¡Listo! Lo agregamos a tu carrito.');
    } catch (err) {
      this.say(err.message || 'No se pudo agregar. Inténtalo de nuevo.', true);
    } finally {
      this.addBtn.classList.remove('is-busy');
    }
  }
}

const init = () => document.querySelectorAll('[data-tc-pdp]').forEach((el) => {
  if (!el.tcProduct) el.tcProduct = new TcProduct(el);
});
init();
document.addEventListener('shopify:section:load', init);

/* ---------- Pestañas de la tabla de medidas ---------- */
const initTabs = () => document.querySelectorAll('[data-tc-size]').forEach((box) => {
  if (box.dataset.ready) return;
  box.dataset.ready = '1';
  const tabs = [...box.querySelectorAll('[data-tc-tab]')];
  const panels = [...box.querySelectorAll('[data-tc-panel]')];
  const pick = (key) => {
    if (!panels.some((p) => p.dataset.tcPanel === key)) return;
    tabs.forEach((t) => {
      const on = t.dataset.tcTab === key;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
    });
    panels.forEach((p) => (p.hidden = p.dataset.tcPanel !== key));
  };
  tabs.forEach((t) => {
    t.addEventListener('click', () => pick(t.dataset.tcTab));
    t.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      const i = tabs.indexOf(t) + (e.key === 'ArrowRight' ? 1 : -1);
      const next = tabs[(i + tabs.length) % tabs.length];
      next.focus();
      pick(next.dataset.tcTab);
    });
  });
  document.addEventListener('tc:corte', (e) => pick(e.detail.corte));
});
initTabs();
document.addEventListener('shopify:section:load', initTabs);
